export default __webpack_public_path__ + "static/media/adform-logo.04c12dad.svg";